module.exports = __webpack_public_path__ + "img/icon_jkyl.7d24b74e.png";